import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const getAuthHeaders = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const OdemeLoglari = () => {
  document.title = "Ödeme Logları | HarmanaGEL";

  const [loglar, setLoglar] = useState([]);
  const [userMap, setUserMap] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // NOT: ODEME_LOGLARI'nda KULLANICILAR navigation property'si YOK (sadece KULLANICI_ID).
  // $expand=KULLANICILAR 400/404 veriyordu. Kullanıcı adlarını ayrı çekip map'liyoruz.
  const fetchLoglar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const [logRes, userRes] = await Promise.all([
        fetch(`${BASE_URL}/ODEME_LOGLARI?$top=500&$orderby=TARIH desc`, { headers: getAuthHeaders() }),
        fetch(`${BASE_URL}/KULLANICILAR?$select=ID,AD_SOYAD,Mail_Adress&$top=10000`, { headers: getAuthHeaders() }),
      ]);
      const logData = await logRes.json();
      const userData = await userRes.json();
      const map = {};
      (userData?.value || []).forEach((u) => { map[u.ID] = u; });
      setUserMap(map);
      if (logData && logData.value) setLoglar(logData.value);
      else if (logData?.error) setError(logData.error.message || "Loglar yüklenemedi.");
    } catch (err) {
      setError("Loglar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLoglar();
  }, []);

  const durumBadge = (durum) => {
    const renkler = { "Basarili": "success", "Basarisiz": "danger", "Beklemede": "warning", "Basarılı": "success", "Başarısız": "danger", "Başarılı": "success" };
    return <Badge color={renkler[durum] || "secondary"}>{durum || "Bilinmiyor"}</Badge>;
  };

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Kullanıcı",
      accessorKey: "KULLANICI_ID",
      enableSorting: false,
      enableColumnFilter: true,
      cell: (cell) => {
        const u = userMap[cell.getValue()];
        return u ? (
          <div>
            <div className="fw-medium">{u.AD_SOYAD}</div>
            <small className="text-muted">{u.Mail_Adress}</small>
          </div>
        ) : <span className="text-muted">{cell.getValue() ? `Kullanıcı #${cell.getValue()}` : "-"}</span>;
      },
    },
    {
      header: "Sipariş No",
      accessorKey: "SIPARIS_NO",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => <span className="font-monospace small">{cell.getValue() || "-"}</span>,
    },
    {
      header: "Tutar",
      accessorKey: "ISLEM_TUTARI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const v = cell.getValue();
        return v != null ? <span className="fw-bold">{parseFloat(v).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺</span> : "-";
      },
    },
    {
      header: "Durum",
      accessorKey: "DURUM",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => durumBadge(cell.getValue()),
    },
    {
      header: "IP Adresi",
      accessorKey: "IP_ADRESI",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => <span className="font-monospace small">{cell.getValue() || "-"}</span>,
    },
    {
      header: "Tarih",
      accessorKey: "TARIH",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        return d ? new Date(d).toLocaleString("tr-TR") : "-";
      },
    },
  ], [userMap]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Ödeme Logları" />

          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="card-title mb-0">Ödeme Logları</h4>
                    <Button color="primary" size="sm" onClick={fetchLoglar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={loglar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Log ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OdemeLoglari;
